import { render, staticRenderFns } from "./OverdueTray.vue?vue&type=template&id=3cd22774&scoped=true"
import script from "./OverdueTray.vue?vue&type=script&lang=js"
export * from "./OverdueTray.vue?vue&type=script&lang=js"
import style0 from "./OverdueTray.vue?vue&type=style&index=0&id=3cd22774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd22774",
  null
  
)

export default component.exports